import Vue from 'vue'
import VueRouter from 'vue-router'
import { ifAuthenticated, ifNotAuthenticated, signinWithEmailAndToken } from '@/libs/acl/routeProtection'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/signin/email/:email/token/:token',
            name: 'signinWithEmailAndToken',
            props: route => ({ email: route.params.email, token: route.params.token }),
            beforeEnter: signinWithEmailAndToken
        },
        {
            path: '/signin/email/:email/token/:token/from/:from',
            name: 'signinWithEmailAndTokenAndFrom',
            props: route => ({ email: route.params.email, token: route.params.token }),
            beforeEnter: signinWithEmailAndToken
        },
        {
            path: '/home',
            redirect: '/'
        },
        {
            path: '/',
            name: 'home',
            component: () => import('@/views/Home.vue'),
            meta: {
                pageTitle: 'Home',
                breadcrumb: [
                    {
                        text: 'Home',
                        active: true
                    }
                ]
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/signin',
            name: 'auth-login',
            component: () => import('@/views/Login.vue'),
            meta: {
                layout: 'full',
                resource: 'Auth',
                redirectIfLoggedIn: true
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/privacy',
            name: 'privacy-public',
            props: (route) => ({ locale: route.query.locale, theme: route.query.theme }),
            component: () => import('@/views/LoginPrivacy.vue'),
            meta: {
                layout: 'full',
                resource: 'Auth',
                action: 'read'
            }
        },
        {
            path: '/forgot-password',
            name: 'auth-forgot-password',
            component: () => import('@/views/ForgotPassword.vue'),
            meta: {
                layout: 'full',
                resource: 'Auth',
                redirectIfLoggedIn: true
            }
        },
        {
            path: '/error-404',
            name: 'error-404',
            component: () => import('@/views/error/Error404.vue'),
            meta: {
                layout: 'full',
                resource: 'Auth',
                action: 'read'
            }
        },
        {
            path: '/password',
            name: 'password',
            component: () => import('@/views/Password.vue'),
            meta: {
                pageTitle: 'Password',
                breadcrumb: [
                    {
                        text: 'Password',
                        active: true
                    }
                ]
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/otp',
            name: 'otp',
            component: () => import('@/views/OTP.vue'),
            meta: {
                pageTitle: 'OTP',
                breadcrumb: [
                    {
                        text: 'OTP',
                        active: true
                    }
                ]
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: () => import('@/views/Agreement.vue'),
            meta: {
                pageTitle: 'Agreement',
                breadcrumb: [
                    {
                        text: 'Agreement',
                        active: true
                    }
                ]
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/privacy-documents',
            name: 'privacy',
            component: () => import('@/views/Privacy.vue'),
            meta: {
                pageTitle: 'Privacy',
                breadcrumb: [
                    {
                        text: 'Privacy',
                        active: true
                    }
                ]
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '*',
            redirect: 'error-404'
        }
    ]
})

export default router
